import axios from 'axios'

export default {
  async getAllPlans () {
    return await axios.get('/api/spa/v1/plan')
  },
  async createPlan (params) {
    return await axios.post('/api/spa/v1/plan', params)
  },
  async unsubscribeUser (params) {
    return await axios.post('/api/spa/v1/subscription/unsubscribe/user/' + params.id, params)
  },
  async deletePlan (id) {
    // return await this.sleep(1300)
    return await axios.delete('/api/spa/v1/plan/' + id)
  },
  async sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
}
